// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2kF9v","icon":"SortAdornment_icon__FvLMy","up":"SortAdornment_up__cPjIF","down":"SortAdornment_down__R5seM","active":"SortAdornment_active__3wOSO"};